import { alpha } from '@mui/material/styles';

/** Shared look of the TC dashboard v2 cards (mockup: 01-dashboard/mockups/tc-dashboard-v2.html). */

export const cardSx = {
  bgcolor: 'background.paper',
  borderRadius: '16px',
  border: '1px solid',
  borderColor: 'divider',
  boxShadow: '0 1px 2px rgba(16,42,44,.04), 0 6px 20px rgba(16,42,44,.06)',
  p: '18px 20px',
  minWidth: 0,
};

export const heroSx = {
  background: 'linear-gradient(135deg, #134e4a 0%, #1f6f6a 55%, #2a9d8f 100%)',
  color: '#fff',
  border: 0,
};

// tone → MUI palette key
export const TONE_PALETTE = { red: 'error', amber: 'warning', blue: 'info', teal: 'primary', green: 'success', up: 'success', down: 'error', grey: 'grey' };

export const toneColor = (theme, tone) => {
  if (tone === 'grey') return theme.palette.text.secondary;
  return theme.palette[TONE_PALETTE[tone] || 'primary'].main;
};
export const toneSoft = (theme, tone) => alpha(toneColor(theme, tone), theme.palette.mode === 'dark' ? 0.2 : 0.12);

export const labelSx = { fontSize: '0.75rem', fontWeight: 600, color: 'text.secondary', textTransform: 'uppercase', letterSpacing: '.04em' };
export const valueSx = { fontSize: '1.75rem', fontWeight: 800, letterSpacing: '-.02em', lineHeight: 1.2 };
